// Names of credit memo PDFs, matching the backend's CreditMemoFileNames:
// Credit_Memo_Good_Trucking_draft.pdf, Credit_Memo_Good_Trucking_v2.pdf, Credit_Memo_Good_Trucking_v2_approved.pdf
const MAX_BUSINESS_LENGTH = 60

const fileSafe = (value) => {
  if (!value) return ''
  let safe = value.normalize('NFD').replace(/\p{M}/gu, '')
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  if (safe.length > MAX_BUSINESS_LENGTH) safe = safe.slice(0, MAX_BUSINESS_LENGTH).replace(/_+$/, '')
  return safe
}

const base = (businessName) => {
  const safe = fileSafe(businessName)
  return safe ? `Credit_Memo_${safe}` : 'Credit_Memo'
}

export const creditMemoDraftFileName = (businessName) => `${base(businessName)}_draft.pdf`

export const creditMemoVersionFileName = (businessName, versionNumber, approved) =>
  `${base(businessName)}_v${versionNumber}${approved ? '_approved' : ''}.pdf`
